import React from 'react'
import { TestAttributesConfig } from 'react-test-attributes'
import GAEventContextManager from 'shared/contexts/ga-event-manager'
import ModalContextManager from 'shared/contexts/modal-manager'
import ReduxBridgeManager from 'shared/contexts/redux-bridge-manager'
import RefreshDataContextManager from 'shared/contexts/refresh-data-manager'
import { attributeName } from 'shared/util/cy-test'
import CollectionsManager from 'shared/contexts/add-to-collections-manager'
import EditAPIContextManager from 'shared/contexts/edit-api-manager'
import VideoInlinePlayManager from 'shared/contexts/video-inline-play-manager'
import VideoLoopManager from 'shared/contexts/video-loop-manager'
import VideoMainManager from 'shared/contexts/video-main-manager'
import { FlashMessagesProvider } from './components/flash-message/flash-message'

type ContextManagersProps = {
    children: React.ReactNode
}

const ContextManagers = ({ children }: ContextManagersProps) => (
    <ReduxBridgeManager>
        <GAEventContextManager>
            <TestAttributesConfig value={{ suffix: attributeName, enableInProductionMode: true }}>
                <VideoLoopManager>
                    <VideoInlinePlayManager>
                        <VideoMainManager>
                            <RefreshDataContextManager>
                                <EditAPIContextManager>
                                    <CollectionsManager>
                                        <ModalContextManager>
                                            <FlashMessagesProvider>{children}</FlashMessagesProvider>
                                        </ModalContextManager>
                                    </CollectionsManager>
                                </EditAPIContextManager>
                            </RefreshDataContextManager>
                        </VideoMainManager>
                    </VideoInlinePlayManager>
                </VideoLoopManager>
            </TestAttributesConfig>
        </GAEventContextManager>
    </ReduxBridgeManager>
)

export default ContextManagers
